import React, { Component } from "react";
import "./style.css";

import { connect } from "react-redux";
import { call } from "redux-saga/effects";
import CustomReduxForm from "../../components/materialform/customform";
import beep from '../../static/sounds/beep1sec.mp3';
import 'react-h5-audio-player/lib/styles.css';
/* import { FileUpload } from 'primereact/fileupload'; */
import FormControlLabel from '@mui/material/FormControlLabel';
import 'react-h5-audio-player/lib/styles.css';
import $ from 'jquery';
import { Beforeunload } from 'react-beforeunload';
import { loadCaptchaEnginge, LoadCanvasTemplate, validateCaptcha } from 'react-simple-captcha';
import AddIcon from '@mui/icons-material/Add';
import {
    getResponseMessage, getIdConversation, getSelectedCompanyForm, getConversationData, getNewChat,
    getCompany, getCompanyId, getHorario, getReduxCompanyForm, getPlaySound, getInfoEncuesta,
    getInfoFormClient, enableFormClient, getUploading, esperandoConv, getStartWidget,
    creandoConversacion, isEnabledCaptchaValidation, sendingFlow, iniciaChatAbierto, chatOpened,
    getTypeWriterWeb
} from "./selectors";



import {
    LISTENER_RESPONSE,
    TEXT_RESPONSE,
    SEND_RESPONSE,
    START_CONVERSATION,
    LOAD_CONVERSATION,
    getLoginButton,
    UPDATE_FIELD_ATTRIBUTE,
    getEncuestaButton,
    FORM_ENCUESTA,
    START_WIDGET,
    ENCUESTA_CONF,
    SHOW_WIDGET,
    HANDLER_FILE_MESSAGE,
    SVG_ICONO_EQUIS,
    CLIENTE_ALCALDIA,
    ICONO_SEND_OSCURO,
    INICIAR_CHAT_ABIERTO,
    CAMBIAR_ESTADO_CHAT_ABIERTO,
    ICONO_SEND_RED,
    CONSULTA_TYPE_WRITER_WEB,
    CLIENTE_IDEAM,
    CLIENTE_AGN
} from './constants';

import { Widget, dropMessages } from 'react-chat-widget';
import 'react-chat-widget/lib/styles.css';
import { storeInSession, getFromSession, removeItems } from "../../controller/session";
import { ReactMic } from 'react-mic';
import CustomForm from "../../components/customform/customform";
/* import { Message } from 'primereact/message'; */
import { IconButton } from "@material-ui/core";
import { Mic, SendRounded } from "@material-ui/icons";
import AccessibleChatWidget, { CustomCaptcha, CustomSpinner } from "./components";
import InputFiles from 'react-input-files';
import { renderCustomComponent } from 'react-chat-widget';



class ComponentAuth extends Component {
    constructor(props) {
        super(props);

        const { startWidget, containerData } = props;

        startWidget(containerData);

        this.state = {
            record: false,
            valueCaptcha: '',
            captchaValidado: false,
            errorCaptchaInvalido: false,

        }
        this.onStop = this.onStop.bind(this);
        this.doSubmit = this.doSubmit.bind(this);
    }
    startRecording = () => {
        this.setState({ record: true });
        const soundWave = document.querySelector('.sound-wave')
        soundWave.style.display = 'block'
        const rwcSender = document.querySelector('.rcw-send')
        const sendAudio = document.querySelector('.attach-widget-send-audio')
        if (rwcSender) {
            rwcSender.style.display = 'none'
        }
        if (sendAudio) {
            sendAudio.style.display = 'block'
        }

        soundWave.setAttribute('title', "...Grabando Audio")
    }

    stopRecording = () => {
        this.setState({ record: false });
    }

    onData(recordedBlob) {
        //console.log('chunk of real-time data is: ', recordedBlob);
    }

    lauchChatWidget = () => {
        const { cambiarEstadoChatAbiertoTrue } = this.props

        setTimeout(() => {

            let button = $(".chat-closed .rcw-launcher");
            let buttonChat = $(".rcw-widget-container .rcw-launcher");
            let body = $('body');

            if (buttonChat) {
                //console.log('single buttonChat');
                buttonChat.click();
                body.addClass('chat-opened');
            } else if (button) {
                //console.log('single button');
                button.click();
            }

            cambiarEstadoChatAbiertoTrue()
        }, 2500);

    }

    onStop(recordedBlob) {
        //console.log('***chunk of onStop: ***', recordedBlob)
        const sessionObject = getFromSession('idConversartion');
        const { idConversartion, startConversation } = sessionObject ? sessionObject : {};
        const { handlerFileMessage } = this.props;
        const soundWave = document.querySelector('.sound-wave').style.display = 'none';
        const rwcSender = document.querySelector('.rcw-send');
        rwcSender.style.display = 'block'
        const sendAudio = document.querySelector('.attach-widget-send-audio')
        if (sendAudio) {
            sendAudio.style.display = 'none'
        }
        if (!idConversartion) {
            startConversation(recordedBlob)
        } else {
            handlerFileMessage({ files: [recordedBlob], isVoiceRecord: true })
        }

    }



    validations = (values) => {
        const errors = {}
        console.log(values)
        const requiredFields = [
            'mail',
            'terminos',
            'nombre',
            'subject',
            'related',
        ]

        requiredFields.forEach(field => {
            if (!values[field]) {
                errors[field] = 'Este campo es obligatorio'
            }
        })
        if (
            values.mail &&
            !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.mail)
        ) {
            errors.mail = 'El correo ingresado no es inválido'
        }

        return errors
    }

    onUnload = e => {
        e.preventDefault();
        const clienteBody = {
            company: '1020',
            nombre: 'cerrada',
            mail: 'cerrada',
            motivo: 'cerrada'
        }
        const urlConv = 'https://us-central1-chat-asesores-3.cloudfunctions.net/nuevaConversacionWeb';
        const response = call(fetch, urlConv, {
            method: 'POST',
            headers: {
                accept: 'application/json, text/plain, */*',
                'content-type': 'application/json',
                'Cache-Control': 'no-cache',
                'cache-control': 'no-cache',
            },
            body: JSON.stringify(clienteBody)
        });

        //alert('adasdf')
    };


    cerrar() {
        let company = getFromSession('company_id')
        let idConv = getFromSession('idConversartion')
        var url = process.env.REACT_APP_ABANDONO;
        var url = url + '?idConv=' + idConv.idConversartion + '&idCompany=' + company;
        navigator.sendBeacon(url, '');
    }
    componentWillMount() {

        const { consultaTypeWriter } = this.props;

        consultaTypeWriter();
    }

    componentDidMount() {

        const { listenerResponse, containerData, company, chatOpened } = this.props;
        const sessionObject = getFromSession('idConversartion');
        const { idConversartion } = sessionObject ? sessionObject : {};
        const chatLauncher = document.querySelector('.rcw-launcher').style.display = 'none';

        let chatClosedLauncher = $('.rcw-close-widget-container .rcw-launcher');

        if (chatClosedLauncher) {

            if (containerData.company === CLIENTE_ALCALDIA) {

                var buttonImage = document.querySelector('.rcw-launcher img');
                buttonImage.setAttribute('src', "https://firebasestorage.googleapis.com/v0/b/chat-asesores-3.appspot.com/o/alcaldiaBogota%2FbotonChatico.png?alt=media&token=db90b93a-c780-4ade-a611-20d5b193e97c");
            }

            if (containerData.company === CLIENTE_IDEAM) {
                var buttonImage = document.querySelector('.rcw-launcher img');
                buttonImage.setAttribute('src', "https://storage.googleapis.com/chat-asesores-3.appspot.com/ideam/gaiaInicioBot2.png");
            }

            if (containerData.company === CLIENTE_AGN) {
                var buttonImage = document.querySelector('.rcw-launcher img');
                buttonImage.setAttribute('src', "https://storage.googleapis.com/chat-asesores-3.appspot.com/agn/Rosa_chat_bot_logo-min.png");
            }

            chatClosedLauncher.title = 'Hola ¿En qué puedo ayudarte?';
        }
        const $this = this;


        $(document).on('click', '.fake-button.close', () => {
            $this.hideConversation();
        });

        if (idConversartion) {

            storeInSession('idConversartion', JSON.stringify({ idConversartion }));
            listenerResponse(idConversartion);

        } else {
            const chatContainer = document.querySelector('.rcw-widget-container');
            chatContainer.classList.add('chat-closed');

            $(document).on('click', '.chat-closed .rcw-launcher', () => {
                $this.showConversation();
            });

        }


        $(document).on('click', '.rcw-close-button', (e) => {

            $('body').removeClass('chat-opened');

            document.querySelector('.main-wrapper').setAttribute('style', 'z-index: 599!important');
            document.querySelector('.rcw-widget-container').setAttribute('style', 'width: 0%!important');
            const soundWave = document.querySelector('.sound-wave')
            if (soundWave) {
                soundWave.style.display = 'none';

            }
            const sendAudio = document.querySelector('.attach-widget-send-audio')

            if (sendAudio) {
                sendAudio.style.display = 'none';
            }

            if (containerData.company === CLIENTE_ALCALDIA) {

                var containerMessages = document.querySelector('.chat-opened');
                var button = document.querySelector('.rcw-launcher');
                var buttonImage = document.querySelector('.rcw-launcher img');
                if (containerMessages == null || !containerMessages) {

                    if (buttonImage) {
                        button.style.padding = "0px 0px 0px 0px";
                        buttonImage.style.width = "62px"
                        buttonImage.setAttribute('src', "https://firebasestorage.googleapis.com/v0/b/chat-asesores-3.appspot.com/o/alcaldiaBogota%2FbotonChatico.png?alt=media&token=db90b93a-c780-4ade-a611-20d5b193e97c");
                    }
                } else {
                    buttonImage.removeAttribute("width")
                    buttonImage.style.width = "20px"
                    button.style.width = "48px"
                    button.style.height = "48px"

                    buttonImage.setAttribute('src', SVG_ICONO_EQUIS)
                }
            }

            if (containerData.company === CLIENTE_IDEAM) {

                var containerMessages = document.querySelector('.chat-opened');
                var button = document.querySelector('.rcw-launcher');
                var buttonImage = document.querySelector('.rcw-launcher img');
                if (containerMessages == null || !containerMessages) {

                    if (buttonImage) {
                        button.style.padding = "0px 0px 0px 0px";
                        buttonImage.style.width = "62px"
                        buttonImage.setAttribute('src', "https://storage.googleapis.com/chat-asesores-3.appspot.com/ideam/gaiaInicioBot2.png");
                    }
                } else {
                    buttonImage.removeAttribute("width")
                    buttonImage.style.width = "20px"
                    button.style.width = "48px";
                    button.style.height = "48px";
                    button.style.borderRadius = "50%";
                    buttonImage.setAttribute('src', SVG_ICONO_EQUIS)
                }
            }

            if (containerData.company === CLIENTE_AGN) {

                var containerMessages = document.querySelector('.chat-opened');
                var button = document.querySelector('.rcw-launcher');
                var buttonImage = document.querySelector('.rcw-launcher img');
                if (containerMessages == null || !containerMessages) {

                    if (buttonImage) {
                        button.style.padding = "0px 0px 0px 0px";
                        buttonImage.style.width = "62px"
                        buttonImage.setAttribute('src', "https://storage.googleapis.com/chat-asesores-3.appspot.com/agn/Rosa_chat_bot_logo-min.png");
                    }
                } else {
                    buttonImage.removeAttribute("width")
                    buttonImage.style.width = "20px"
                    button.style.width = "48px";
                    button.style.height = "48px";
                    button.style.borderRadius = "50%";
                    buttonImage.setAttribute('src', SVG_ICONO_EQUIS)
                }



                var formInicio = document.querySelector('.formInicio');
                if (formInicio) {

                    var oldIcon = document.querySelector('.MuiSvgIcon-root.icon-title');

                    if (oldIcon) {
                        const img = document.createElement("img");
                        img.className = "icon-title";
                        img.src = SVG_ICONO_EQUIS;
                        img.style.width = "20px";
                        img.style.height = "20px";
                        img.style.objectFit = "contain";

                        oldIcon.replaceWith(img);
                    }

                } else {
                    var bottomIcon = document.querySelector('.rcw-launcher');
                    if (bottomIcon) {
                        bottomIcon.style.position = "relative";
                        bottomIcon.style.right = "-23px";
                    }
                }

            }
        });

        $(document).on('click', '.rcw-launcher', (e) => {

            const $this = $(e.currentTarget);

            if ($this.hasClass('rcw-hide-sm')) {

                $('body').addClass('chat-opened');
                const formInicio = document.querySelector('.form-container')
                if (formInicio)
                    formInicio.style.bottom = '20px';
                if (this.state.record) {
                    const soundWave = document.querySelector('.sound-wave')
                    soundWave.style.display = 'block';
                    const rwcSender = document.querySelector('.rcw-send');
                    rwcSender.style.display = 'none'
                    const sendAudio = document.querySelector('.attach-widget-send-audio')
                    if (sendAudio) {
                        sendAudio.style.display = 'block';
                    }
                }
                document.querySelector('.main-wrapper').setAttribute('style', 'z-index: 600!important');
                document.querySelector('.rcw-widget-container').setAttribute('style', '');
            } else {

                $('body').removeClass('chat-opened');
                const soundWave = document.querySelector('.sound-wave')
                const sendAudio = document.querySelector('.attach-widget-send-audio')
                if (soundWave) {
                    soundWave.style.display = 'none';
                }
                if (sendAudio) {
                    sendAudio.style.display = 'none';
                }

            }

        })


        if (chatOpened) {
            this.lauchChatWidget();
        }

        //funcion para evitar que el enter envie el form si este no esta completo
        this.attachFormSubmitListener();

        //alt y title de imagen title
        // ALT + TITLE + ARIA (accesibilidad)
        const addAccessibility = () => {
            let updated = false;

            // Logo
            const logo = document.querySelector(".image-title");
            if (logo && !logo.hasAttribute("alt")) {
                logo.setAttribute("alt", "Logo institucional del asistente virtual");
                logo.setAttribute("title", "Logo institucional del asistente virtual");
                updated = true;
            }

            const avatar = document.querySelector(".rcw-avatar");
            if (avatar && !avatar.hasAttribute("alt")) {
                avatar.setAttribute("alt", "Avatar del asistente virtual");
                avatar.setAttribute("title", "Avatar del asistente virtual");
                updated = true;
            }

            // Botón de formulario principal (MUI)
            const buttons = document.querySelectorAll("button");
            buttons.forEach((btn) => {
                const label = btn.innerText?.trim().toLowerCase();
                if (label === "enviar" && !btn.hasAttribute("aria-label")) {
                    btn.setAttribute("aria-label", "Enviar formulario para iniciar el chat");
                    btn.setAttribute("title", "Enviar formulario para iniciar el chat");
                    updated = true;
                }
            });

            // Botón de envío del widget (chat)
            const sendButton = document.querySelector(".rcw-send");
            if (sendButton && !sendButton.hasAttribute("aria-label")) {
                sendButton.setAttribute("aria-label", "Enviar mensaje");
                sendButton.setAttribute("title", "Enviar mensaje");
                updated = true;
            }

            return updated;
        };

        // Ejecutar y seguir intentando hasta que todo esté accesible
        if (!addAccessibility()) {
            let tries = 0;
            const interval = setInterval(() => {
                tries++;
                if (addAccessibility() || tries > 20) {
                    clearInterval(interval);
                }
            }, 500);
        }

        const inputs = document.querySelectorAll("form[name='chatReduxForm'] input, form[name='chatReduxForm'] select, form[name='chatReduxForm'] textarea");
        inputs.forEach((input) => {
            input.addEventListener("keydown", (e) => {
                if (e.key === "Enter") {
                    e.preventDefault();
                    e.stopPropagation();

                    input.blur(); // fuerza blur para activar validaciones

                    setTimeout(() => {
                        if (this.validations(this.props.reduxCompanyForm)) {
                            console.log("✅ Formulario válido (se puede enviar)");
                            // this.props.startConversation(this.props.reduxCompanyForm);
                        } else {
                            console.warn("❌ Faltan campos obligatorios");
                        }
                    }, 100);
                }
            });
        });

    }

    attachFormSubmitListener() {
        const form = document.querySelector("form[name='chatReduxForm']");
        if (!form) return;

        // Evitar duplicar listeners si el componente se re-renderiza
        if (form.dataset.listenerAttached === "true") return;
        form.dataset.listenerAttached = "true";

        form.addEventListener("submit", (e) => {
            e.preventDefault();
            e.stopPropagation();

            const { reduxCompanyForm } = this.props;

            // ✅ Ejecuta la validación personalizada
            if (this.validations(reduxCompanyForm)) {
                console.log("✅ Validación completa, se puede enviar.");
                this.props.startConversation(reduxCompanyForm);
            } else {
                console.warn("❌ Validación fallida, formulario incompleto.");

                // 🔹 Marca los campos inválidos visualmente (opcional)
                const requiredFields = form.querySelectorAll("input[required], select[required], textarea[required]");
                requiredFields.forEach(field => {
                    if (!field.value.trim()) {
                        field.classList.add("input-error");
                        field.setAttribute("aria-invalid", "true");
                    } else {
                        field.classList.remove("input-error");
                        field.removeAttribute("aria-invalid");
                    }
                });
            }
        });
    }

    doSubmit = (value) => {
        const { startConversation } = this.props
        if (validateCaptcha(value) === true) {
            //alert('Captcha Matched');
            loadCaptchaEnginge(6);
            this.setState({
                valueCaptcha: "",
                captchaValidado: true,
            })
            startConversation({ subject: "hola", captcha: true })
        }
        else {
            //alert('Captcha Does Not Match');
            this.setState({
                valueCaptcha: "",
                captchaValidado: false,
                errorCaptchaInvalido: true
            })
        }
    };

    getCustomLauncher = (handleToggle) =>
        <button onClick={handleToggle}>CHAT!</button>

    addCustomButtonLogo(imagePath) {
        var button = document.querySelector('.rcw-launcher img');


        if (button) {

            button.setAttribute('src', imagePath);
        }

    }


    addCustomHeader(imageSource) {
        setTimeout(() => {
            let chatHeader = document.querySelector('.rcw-header');
            let currentImage = document.querySelector('.chat-image-header');
            let imagePath = imageSource ? imageSource : '';


            var image = document.createElement("IMG");
            image.setAttribute('class', 'chat-image-header');
            if (imagePath) {
                image.setAttribute("src", imagePath);
            }

            if (chatHeader) {

                if (currentImage !== undefined) {
                    $('.chat-image-header').remove();
                }
                chatHeader.appendChild(image);
            }
        }, 10);
    }

    componentDidUpdate(prevProps) {

        const { playSound, enableFormClient, containerData, startWidget, startWidgetFlag, flagNewChat,
            conversationData, enviarEncuesta, showCaptcha, iniciaChatAbierto, cambiarEstadoChatAbiertoFalse, company } = this.props;
        const sessionObject = getFromSession('idConversartion');
        const { idConversartion } = sessionObject ? sessionObject : {};
        var containerMessages = document.querySelector('.chat-opened');
        if (document.querySelector('.rcw-launcher')) {
            document.querySelector('.rcw-launcher').title = company.botonTitle ? company.botonTitle : 'Hola ¿En qué puedo ayudarte?';
        }

        if (iniciaChatAbierto || containerMessages) {

            var iconSend = document.querySelector('.rcw-send img')
            var button = document.querySelector('.rcw-launcher');
            if (iconSend) {

                if (containerData.company === CLIENTE_ALCALDIA) {

                    button.style.width = "48px"
                    button.style.height = "48px"
                    button.style.backgroundColor = "#d82200"
                    iconSend.setAttribute('src', ICONO_SEND_RED);
                } else {
                    iconSend.setAttribute('src', ICONO_SEND_OSCURO);
                }

                iconSend.setAttribute('title', "Enviar mensaje")
            }
            cambiarEstadoChatAbiertoFalse()

        }

        let imageSource = false;
        let canvasCaptcha = document.querySelector('#canv');
        let inputMessage = document.querySelector(".rcw-new-message");
        let textInput = document.querySelector('.chat-widget-panel');

        if (this.props.startWidgetFlag && prevProps.startWidgetFlag !== this.props.startWidgetFlag
        ) {

            let rcWLauncher = document.querySelector('.rcw-launcher');
            if (rcWLauncher) {
                rcWLauncher.style.display = 'flex';
            }

            $(document).on('click', '.rcw-launcher', (e) => {
                imageSource = this.props.company ? this.props.company.logoNombre : false;
                this.addCustomHeader(imageSource);
                let iconSend = document.querySelector('.rcw-send-icon')
                if (iconSend) {
                    if (containerData.company === CLIENTE_ALCALDIA) {
                        console.log('entroo alcaldia');
                        iconSend.setAttribute('src', ICONO_SEND_RED);
                    } else {
                        iconSend.setAttribute('src', ICONO_SEND_OSCURO);
                    }
                    iconSend.setAttribute('title', "Enviar mensaje")
                }

                if (containerData.company === CLIENTE_ALCALDIA) {
                    var containerMessages = document.querySelector('.chat-opened');
                    var button = document.querySelector('.rcw-launcher');
                    var buttonImage = document.querySelector('.rcw-launcher img');

                    if (containerMessages == null && !iniciaChatAbierto) {

                        if (buttonImage) {
                            button.style.padding = "0px 0px 0px 0px";
                            buttonImage.style.width = "73px";
                            button.style.width = "70px"
                            button.style.height = "70px"
                            buttonImage.setAttribute('src', "https://firebasestorage.googleapis.com/v0/b/chat-asesores-3.appspot.com/o/alcaldiaBogota%2FbotonChatico.png?alt=media&token=db90b93a-c780-4ade-a611-20d5b193e97c");
                            button.style.backgroundColor = "rgba(0, 0, 0, 0)"
                        }
                    } else {
                        button.style.backgroundColor = "#d82200"
                        buttonImage.removeAttribute("width")
                        buttonImage.style.width = "20px"
                        button.style.width = "48px"
                        button.style.height = "48px"
                        buttonImage.setAttribute('src', SVG_ICONO_EQUIS)

                    }
                }

                if (containerData.company === CLIENTE_IDEAM) {
                    const containerMessages = document.querySelector('.chat-opened');
                    const button = document.querySelector('.rcw-launcher');
                    const buttonImage = document.querySelector('.rcw-launcher img');

                    if (button && buttonImage) {
                        if (containerMessages == null && !iniciaChatAbierto) {
                            // 🔹 Estado: chat cerrado → GIF grande centrado
                            button.style.width = "100px";
                            button.style.height = "80px";
                            button.style.background = "transparent";
                            button.style.border = "none";
                            button.style.display = "grid";
                            button.style.alignItems = "center";
                            button.style.justifyContent = "center";
                            button.style.padding = "0";
                            button.style.boxShadow = "none";

                            buttonImage.setAttribute(
                                "src",
                                "https://storage.googleapis.com/chat-asesores-3.appspot.com/ideam/gaiaInicioBot2.png"
                            );
                            buttonImage.setAttribute("alt", "Logo Gaia IDEAM");
                            buttonImage.setAttribute("title", "Asistente virtual IDEAM");

                            buttonImage.style.width = "100px";      // Tamaño del GIF
                            buttonImage.style.height = "100px";
                            buttonImage.style.objectFit = "cover";
                            buttonImage.style.margin = "-11px 12px";
                            buttonImage.style.display = "block";
                        } else {
                            // 🔹 Estado: chat abierto → botón normal rojo con ícono X
                            button.style.background = "rgb(1,161,223) linear-gradient(0deg, rgba(0,198,155,1) 10%, rgba(0,144,255,1) 100%)";
                            button.style.display = "flex";
                            button.style.alignItems = "center";
                            button.style.justifyContent = "center";
                            button.style.width = "48px";
                            button.style.height = "48px";
                            button.style.borderRadius = "50%";

                            buttonImage.removeAttribute("width");
                            buttonImage.style.width = "20px";
                            buttonImage.style.height = "20px";
                            buttonImage.style.objectFit = "contain";
                            buttonImage.setAttribute("src", SVG_ICONO_EQUIS);
                            buttonImage.setAttribute("alt", "Cerrar asistente virtual");
                            buttonImage.setAttribute("title", "Cerrar asistente virtual");
                        }
                    }
                }

                if (containerData.company === CLIENTE_AGN) {
                    const containerMessages = document.querySelector('.chat-opened');
                    const button = document.querySelector('.rcw-launcher');
                    const buttonImage = document.querySelector('.rcw-launcher img');
                    const launcher = document.querySelector('.active');
                    console.log(launcher)

                    if (button && buttonImage) {
                        if (containerMessages == null && !iniciaChatAbierto) {
                            // 🔹 Estado: chat cerrado → GIF grande centrado
                            button.style.width = "100px";
                            button.style.height = "80px";
                            button.style.background = "transparent";
                            button.style.border = "none";
                            // button.style.display = "grid";
                            button.style.alignItems = "center";
                            button.style.justifyContent = "center";
                            button.style.padding = "0";
                            button.style.boxShadow = "none";

                            buttonImage.setAttribute(
                                "src",
                                "https://storage.googleapis.com/chat-asesores-3.appspot.com/agn/Rosa_chat_bot_logo-min.png"
                            );
                            buttonImage.setAttribute("alt", "Logo AGN");
                            buttonImage.setAttribute("title", "Asistente virtual AGN");

                            buttonImage.style.width = "100px";      // Tamaño del GIF
                            buttonImage.style.height = "100px";
                            buttonImage.style.objectFit = "cover";
                            buttonImage.style.margin = "-11px 12px";
                            buttonImage.style.display = "block";
                        } else {
                            // 🔹 Estado: chat abierto → botón normal rojo con ícono X
                            button.style.background = "rgb(1,161,223) linear-gradient(0deg, rgba(0,198,155,1) 10%, rgba(0,144,255,1) 100%)";
                            button.style.display = "flex";
                            // button.removeAttribute("position");
                            // button.removeAttribute("rigth");
                            // if (launcher) {
                            //     console.log(launcher, "ll")
                            //     button.style.position = "absolute";
                            //     button.style.rigth = "12px";
                            // }
                            button.style.alignItems = "center";
                            button.style.justifyContent = "center";
                            button.style.width = "48px";
                            button.style.height = "48px";
                            button.style.borderRadius = "50%";

                            buttonImage.removeAttribute("width");
                            buttonImage.style.width = "20px";
                            buttonImage.style.height = "20px";
                            buttonImage.style.objectFit = "contain";
                            buttonImage.setAttribute("src", SVG_ICONO_EQUIS);
                            buttonImage.setAttribute("alt", "Cerrar asistente virtual");
                            buttonImage.setAttribute("title", "Cerrar asistente virtual");
                        }
                    }

                    var formInicio = document.querySelector('.formInicio');
                    if (formInicio) {

                        var oldIcon = document.querySelector('.MuiSvgIcon-root.icon-title');

                        if (oldIcon) {
                            const img = document.createElement("img");
                            img.className = "icon-title";
                            img.src = SVG_ICONO_EQUIS;
                            img.style.width = "20px";
                            img.style.height = "20px";
                            img.style.objectFit = "contain";

                            oldIcon.replaceWith(img);
                        }

                    } else {
                        var bottomIcon = document.querySelector('.rcw-launcher');
                        if (bottomIcon) {
                            bottomIcon.style.position = "relative";
                            bottomIcon.style.right = "-23px";
                        }
                    }

                }


            });
        }

        if (showCaptcha && prevProps.showCaptcha !== showCaptcha && conversationData === false) {
            if (canvasCaptcha) {
                loadCaptchaEnginge(6, 'red', 'white');
            }
        }

        if (conversationData) {
            if (inputMessage) {
                inputMessage.removeAttribute('disabled');
            }
        }

        if (prevProps.conversationData?.estado === 10 && !conversationData) {
            if (canvasCaptcha) {
                loadCaptchaEnginge(6)
            }
        }
        if (this.props.creandoConversacion && prevProps.creandoConversacion !== this.props.creandoConversacion) {
            this.setState({
                captchaValidado: false
            })
        }
        if (enableFormClient && idConversartion) {
            if (textInput) {
                document.querySelector('.chat-widget-panel').classList.remove('container-disabled');
            }
        } else if (!enableFormClient && !idConversartion || !enableFormClient && idConversartion) {
            if (textInput) {
                document.querySelector('.chat-widget-panel').classList.remove('container-disabled');

            }

        }
        if (flagNewChat) {
            let container = document.querySelector('.rcw-widget-container')
            if (container) {
                container.setAttribute('style', 'width: 100%!important');
            }
        }
        if (conversationData && conversationData.agente && conversationData.agente.nombres === "Chatbot" && conversationData.estado === 10) {
            enviarEncuesta(false)
        }
        if (!startWidgetFlag) {
            this.openNewChat();
            startWidget(containerData);
            imageSource = this.props.company ? this.props.company.logoNombre : false;
            this.addCustomHeader(imageSource);
        }
        if (playSound) {
            const audioEl = document.getElementById("audio-element");
            audioEl.play();
        }


        this.attachFormSubmitListener();
        // this.addCustomButtonLogo(this.props.company.avatar);

        // ✅ Asegurar que el formulario de inicio siempre se muestre si no hay conversación activa

        const chatContainer = document.querySelector('.rcw-widget-container');
        const chatClosed = chatContainer?.classList.contains('chat-closed');
        const formInicio = document.querySelector('.form-container.formInicio');

        // Mostrar el formulario solo si el chat está ABIERTO y no hay conversación activa
        if (!idConversartion && !chatClosed && formInicio) {
            formInicio.style.display = 'flex';
            formInicio.style.visibility = 'visible';
        }
        // Ocultar el formulario si el chat está cerrado
        else if (chatClosed && formInicio) {
            formInicio.style.display = 'none';
        }
    }

    showConversation() {

        const { showCaptcha, conversationData, enableFormClient, clientFormConf } = this.props
        let inputMessage = document.querySelector(".rcw-new-message");
        if (document.querySelector('.form-container')) {
            document.querySelector('.form-container').style.display = 'flex';
        }

        if (!conversationData && (enableFormClient || showCaptcha || clientFormConf)) {
            if (inputMessage) {
                //console.log('show conversation, inactivate input messages');
                inputMessage.setAttribute('disabled', true)
            }
        }

        const chatContainer = document.querySelector('.rcw-widget-container');
        chatContainer.classList.remove('chat-closed');
    }

    hideConversation() {

        let rcwHideButton = document.querySelector('.rcw-launcher.rcw-hide-sm');
        let rcwContainer = document.querySelector('.form-container');

        if (rcwHideButton) {
            rcwHideButton.click();
        }

        if (rcwContainer) {
            rcwContainer.style.display = 'none';
        }
        const chatContainer = document.querySelector('.rcw-widget-container');
        chatContainer.classList.add('chat-closed');
    }

    openNewChat() {
        if (document.querySelector('.form-container')) {
            document.querySelector('.form-container').style.display = 'flex';
        }

    }

    onFileUpload = (e) => {
        const { handlerFileMessage } = this.props
        console.log("e targe", e);
        handlerFileMessage(e)


    }



    render() {
        const {
            sendResponse,
            updateAttributes,
            message,
            selectedCompanyForm, startConversation,
            conversationData,
            enviarEncuesta,
            company, horario,
            reduxCompanyForm,
            encuestaConf,
            clientFormConf,
            enableFormClient,
            startWidgetFlag,
            handlerFileMessage,
            uploading,
            creandoConversacion,
            showCaptcha,
            sendingFlow,
            startWidget,
            containerData
        } = this.props;

        const mostrarChat = (startWidgetFlag && !enableFormClient);
        const handleNewUserMessage = (newMessage) => {

            sendResponse({ newMessage, conversationData });
        };

        function sortObjectByKeys(o) {
            return Object.keys(o).sort().reduce((r, k) => (r[k] = o[k], r), {});
        }

        let parametrosEncuesta = (encuestaConf) => {
            let form = [];
            if (encuestaConf) {
                let ordenado = sortObjectByKeys(encuestaConf)
                for (let pregunta in ordenado) {
                    let jsonBase = {
                        label: ordenado[pregunta].nombre,
                        name: ordenado[pregunta].nombreCorto,
                        placeholder: "",
                        hint: "",
                        type: ordenado[pregunta].type,
                        typeForm: ordenado[pregunta].type,
                        value: false,
                        options: [],
                        disable: false,
                    }

                    if (ordenado[pregunta].type === 'ratingStars') {
                        jsonBase['cancel'] = false
                        jsonBase['className'] = "rs-100 fixed-margin"
                        jsonBase['stars'] = 5

                        form.push(jsonBase)
                    } else {
                        jsonBase['options'] = ordenado[pregunta].opcionesRespuesta;
                        jsonBase['className'] = "rs-100"
                        form.push(jsonBase)
                    }
                }
            }
            return form;
        }

        let parametrosFormCliente = (formClienteConf) => {
            let form = [];
            if (clientFormConf) {
                let ordenado = sortObjectByKeys(formClienteConf);
                for (let pregunta in ordenado) {
                    let jsonBase = {
                        label: ordenado[pregunta].nombre,
                        name: ordenado[pregunta].nombreCorto,
                        placeholder: "",
                        hint: "",
                        type: ordenado[pregunta].type,
                        typeForm: ordenado[pregunta].type,
                        value: false,
                        options: [],
                        disable: false,
                    }

                    if (ordenado[pregunta].type === 'select') {
                        jsonBase['options'] = ordenado[pregunta].opcionesRespuesta;
                        jsonBase['className'] = "rs-100"
                        form.push(jsonBase);

                    } else if (ordenado[pregunta].type === 'radio') {
                        jsonBase['options'] = ordenado[pregunta].opcionesRespuesta;
                        jsonBase['className'] = "rs-100 radio radioTerms"
                        form.push(jsonBase);
                    } else {
                        jsonBase['className'] = "rs-100"
                        form.push(jsonBase);
                    }
                }
            } else {
                form = false;
            }
            return form;

        }

        const sessionObject = getFromSession('idConversartion');
        const { idConversartion } = sessionObject ? sessionObject : {};
        let subtitle = `${horario ? horario.textoHorario : ''}`;
        let estadoConv = conversationData && conversationData.estado ? conversationData.estado : null;

        if (idConversartion === undefined) {
            estadoConv = false;
        }


        if (estadoConv === 11) {
            //dropMessages();
            removeItems('clienteData');
            removeItems('idConversartion');
            startWidget(containerData);
        }




        let spinner = <div></div>

        this.addCustomHeader(company.logoNombre);

        return (
            <div className={`chat-demo-wrapper chatico-${company.cuenta}`}>
                <Beforeunload onBeforeunload={(event) => { this.cerrar(); }} />
                {!idConversartion ?
                    <div>
                        {enableFormClient && clientFormConf ?
                            <div className="form-container formInicio" id="formInicio" >
                                {creandoConversacion ? (spinner) :
                                    <React.Fragment>
                                        <CustomReduxForm
                                            formName="chatReduxForm"
                                            customHeader={company.logo}
                                            formTitle={company.nombre}
                                            formSubTitle={subtitle}
                                            items={parametrosFormCliente(clientFormConf)}
                                            className="conversation"
                                            card={false}
                                            handleSubmit={(values) => {
                                                if (this.validations(values)) {
                                                    console.log("pasa validaciones")
                                                    startConversation(reduxCompanyForm);
                                                } else {
                                                    console.log("no pasa ")
                                                    // opcional: marcar errores
                                                }
                                            }}
                                            validations={this.validations}
                                            buttons={
                                                horario && horario.valido
                                                    ? getLoginButton(() => startConversation(reduxCompanyForm))
                                                    : []
                                            }
                                        />
                                        {/* <CustomReduxForm
                                            formName="chatReduxForm"
                                            customHeader={company.logo}
                                            formTitle={company.nombre}
                                            formSubTitle={subtitle}
                                            items={parametrosFormCliente(clientFormConf)}
                                            className="conversation"
                                            card={false}
                                            handleSubmit={() => startConversation(reduxCompanyForm)}
                                            validations={this.validations}
                                            buttons={horario && horario.valido ? getLoginButton(() => startConversation(reduxCompanyForm)) : []}
                                        /> */}
                                        {horario && !horario.valido ?
                                            <FormControlLabel value="worst" label="Estimado usuario, se encuentra fuera de horario para ser atendido." /> : ''}

                                    </React.Fragment>

                                }

                                {!creandoConversacion &&
                                    <React.Fragment>
                                        <div className="fake-field"></div>
                                        <div className="fake-button close">
                                            <button className="rcw-close-button rcw-fake-close-button">
                                                <img src={SVG_ICONO_EQUIS} className="rcw-close" alt="close" />
                                            </button>
                                        </div>
                                    </React.Fragment>}
                            </div>
                            : (showCaptcha &&
                                <div className="form-container formInicio formCaptcha" id="formInicio" >
                                    {creandoConversacion ? (spinner) :
                                        <CustomCaptcha
                                            state={this.state}
                                            subtitle='Para comprobar que es un humano escriba los caracteres que ve en el siguiente recuadro para poder
                                            continuar al chat.'
                                            logo={company.logo}
                                            reloadText="Cambiar caracteres"
                                            doSubmit={this.doSubmit}
                                            setState={this.setState}
                                            renderThis={this}
                                            svgIconX={SVG_ICONO_EQUIS}
                                            placeholder='Escriba el valor del captcha'
                                        />
                                    }
                                </div>
                            )
                        }
                    </div>
                    : false
                }


                {
                    conversationData && conversationData.agente && conversationData.agente.nombres !== "Chatbot" && estadoConv && estadoConv === 10 && encuestaConf ? (
                        <div className="form-container zindex2000 encuestaStyles">
                            <CustomForm
                                formName="conversationForm"
                                items={parametrosEncuesta(encuestaConf)}
                                formTitle="Encuesta de Satisfacción"
                                customHeader={company.logo}
                                formSubtitle="La conversación ha finalizado, ayúdanos a mejorar calificando el servicio prestado."
                                values={selectedCompanyForm}
                                submitted={message}
                                updateAction={updateAttributes}
                                buttons={getEncuestaButton(() => enviarEncuesta(selectedCompanyForm))}
                                className="conversation scroll"
                            >
                            </CustomForm>
                        </div>
                    ) : null
                }

                {
                    (mostrarChat && estadoConv === undefined || !estadoConv || estadoConv !== 10) &&
                    <div className={`chat-widget-panel container-disabled ${sendingFlow ? 'df-sending-msg' : ''}`}>
                        {sendingFlow && <CustomSpinner
                            text={false}
                            className='dfSpinnerContainer'
                            spinnerClassName='dialogFlowSpinner'
                            color='secondary'
                            textClassName='p-text-normal df-cargando'
                            id='dialogFlowSpinner'
                            type='linear'
                        />
                        }

                        {/* <Widget
                            title={company.nombre}
                            subtitle=''
                            className={`chat-widget-container`}
                            senderPlaceHolder='¿En qué te puedo ayudar?'
                            handleNewUserMessage={!idConversartion ? startConversation : handleNewUserMessage}
                            profileAvatar={company.avatar}
                            toggleInputDisabled={false}
                            titleAvatar={company.logoNombre}
                            toggleWidget={true}
                                >
                        </Widget> */}
                        <AccessibleChatWidget
                            company={company}
                            idConversartion={idConversartion}
                            startConversation={startConversation}
                            handleNewUserMessage={handleNewUserMessage}
                        />

                        {uploading ?

                            <div >

                            </div>

                            :
                            <div className="iconsContainer">
                                {idConversartion ? <div className="iconoMicrofono">
                                    <ReactMic
                                        record={this.state.record}
                                        className="sound-wave "
                                        onStop={this.onStop}
                                        onData={this.onData}
                                        strokeColor="#FFFFFF"
                                        backgroundColor="#DC143C"
                                        channelCount={1}
                                        mimeType="audio/wav; codecs=MS_PCM" />
                                    <IconButton
                                        className="attach-widget-microphone"
                                        onClick={this.startRecording}
                                        title="Grabar voz"
                                    >
                                        <Mic style={{ height: '1.3em', width: '2em' }} />
                                    </IconButton>
                                    <IconButton
                                        className="attach-widget-send-audio"
                                        onClick={this.stopRecording}
                                        title="Parar y enviar audio"
                                    >
                                        <SendRounded />
                                    </IconButton>

                                </div> : false
                                }

                                {idConversartion ? <div className="iconoAdjuntar">
                                    <InputFiles accept="*" onChange={this.onFileUpload}>
                                        <IconButton className='attach-widget-file' title="Adjuntar archivo" aria-label="adjuntar" >

                                            <AddIcon />
                                        </IconButton>
                                    </InputFiles>

                                </div> : false}
                            </div>
                        }
                    </div>
                }
                <audio id="audio-element" >
                    <source src={beep}></source>
                </audio>
            </div>



        );
    }
}

const mapStateToProps = state => {
    return {
        responseMessage: getResponseMessage(state),
        idConversartionState: getIdConversation(state),
        reduxCompanyForm: getReduxCompanyForm(state),
        selectedCompanyForm: getSelectedCompanyForm(state),
        esperandoConv: esperandoConv(state),
        conversationData: getConversationData(state),
        flagNewChat: getNewChat(state),
        creandoConversacion: creandoConversacion(state),
        company: getCompany(state), companyId: getCompanyId(state),
        horario: getHorario(state),
        playSound: getPlaySound(state),
        encuestaConf: getInfoEncuesta(state),
        clientFormConf: getInfoFormClient(state),
        enableFormClient: enableFormClient(state),
        uploading: getUploading(state),
        startWidgetFlag: getStartWidget(state),
        showCaptcha: isEnabledCaptchaValidation(state),
        sendingFlow: sendingFlow(state),
        iniciaChatAbierto: iniciaChatAbierto(state),
        chatOpened: chatOpened(state),
        typeWriterWeb: getTypeWriterWeb(state),
    };
};

const mapDispachToProps = dispatch => {
    return {
        updateAttributes: (value) => dispatch({ type: UPDATE_FIELD_ATTRIBUTE, value }),
        sendResponse: (value) => dispatch({ type: SEND_RESPONSE, value }),
        listenerResponse: (value) => dispatch({ type: LISTENER_RESPONSE, value }),
        textResponse: (value) => dispatch({ type: TEXT_RESPONSE, value }),
        startConversation: (value) => dispatch({ type: START_CONVERSATION, value }),
        loadConversation: (value) => dispatch({ type: LOAD_CONVERSATION, value }),
        listenerConversationInfo: (value) => dispatch({ type: LISTENER_RESPONSE, value }),
        enviarEncuesta: (value) => dispatch({ type: FORM_ENCUESTA, value }),
        startWidget: (value) => dispatch({ type: START_WIDGET, value }),
        traerPreguntasEncuesta: (value) => dispatch({ type: ENCUESTA_CONF, value }),
        mostrarWidget: (value) => dispatch({ type: SHOW_WIDGET, value }),
        handlerFileMessage: (value) => dispatch({ type: HANDLER_FILE_MESSAGE, value }),
        cambiarEstadoChatAbiertoTrue: (value) => dispatch({ type: INICIAR_CHAT_ABIERTO, value }),
        cambiarEstadoChatAbiertoFalse: (value) => dispatch({ type: CAMBIAR_ESTADO_CHAT_ABIERTO, value }),
        consultaTypeWriter: (value) => dispatch({ type: CONSULTA_TYPE_WRITER_WEB, value }),
    };
};

export default connect(
    mapStateToProps,
    mapDispachToProps
)(ComponentAuth);